<ng-container *ngIf="!class || class.includes('default')">

  <svg class="large-number-display default" width="110" height="110" (click)="onClick.emit()">
    <foreignObject x="0" y="0" width="110" height="60">
      <xhtml:p class="number">{{number}}</xhtml:p>
    </foreignObject>

    <foreignObject x="10" y="60" width="90" height="60">
      <xhtml:p class="text">{{text}}</xhtml:p>
    </foreignObject>
  </svg>

</ng-container>

<ng-container *ngIf="class && !class.includes('default')">

  <ng-container *ngIf="text">

    <svg class="large-number-display" [ngClass]="class" width="110" height="110" (click)="onClick.emit()">
      <circle cx="55" cy="55" r="53.5" stroke-width="3"/>
      <foreignObject x="0" y="0" width="110" height="60">
        <xhtml:p class="number">{{number}}</xhtml:p>
      </foreignObject>

      <foreignObject x="6" y="60" width="98" height="60">
        <xhtml:p class="text">{{text}}</xhtml:p>
      </foreignObject>
    </svg>


  </ng-container>

  <ng-container *ngIf="!text">

    <svg class="large-number-display" [ngClass]="class" width="110" height="110" (click)="onClick.emit()">
      <circle cx="55" cy="55" r="40" stroke-width="3"/>
      <foreignObject x="0" y="15" width="110" height="60">
        <xhtml:p class="number">{{number}}</xhtml:p>
      </foreignObject>
    </svg>

  </ng-container>

</ng-container>
